import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExclamationTriangle,
    faClock,
    faTools,
    faCheck,
    faBell,
    faCalendar,
    faWrench,
    faBuilding,
    faThermometerHalf,
    faElevator
} from '@fortawesome/free-solid-svg-icons';
import './BuildingMaintenanceDashboard.css';
import ComingSoonModal from '../../../pages/ComingSoon/ComingSoonModal';

// Static data structure matching Fire Safety Dashboard
const stats = [
  {
    key: 'criticalIssues',
    label: 'Critical Issues',
    icon: faExclamationTriangle,
    total: 2,
    failed: 2,
    status: 'alert',
    navTarget: 'defects',
  },
  {
    key: 'scheduledTasks',
    label: 'Scheduled Tasks',
    icon: faClock,
    total: 5,
    failed: 0,
    status: 'warning',
  },
  {
    key: 'totalIssues',
    label: 'Total Issues',
    icon: faTools,
    total: 12,
    failed: 0,
    status: 'good',
  },
  {
    key: 'completed',
    label: 'Completed',
    icon: faCheck,
    total: 8,
    failed: 0,
    status: 'good',
  },
  {
    key: 'plumbingSystems',
    label: 'Plumbing Systems',
    icon: faWrench,
    total: 1,
    failed: 0,
    status: 'good',
    navTarget: 'plumbing',
  },
  {
    key: 'hvacSystems',
    label: 'HVAC Systems',
    icon: faThermometerHalf,
    total: 1,
    failed: 1,
    status: 'warning',
    navTarget: 'heating-cooling',
  },
  {
    key: 'liftMaintenance',
    label: 'Lift Maintenance',
    icon: faElevator,
    total: 1,
    failed: 0,
    status: 'good',
    navTarget: 'lift',
  },
];

const BuildingMaintenanceDashboard = ({ onNavigate }) => {
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [isComingSoonOpen, setIsComingSoonOpen] = useState(false);
  const [comingSoonFeature, setComingSoonFeature] = useState('');
  const attentionItems = stats.filter(item => item.failed > 0);

  return (
    <div className="building-maintenance-dashboard-wrapper">
      <div className="dashboard-header-row">
        <h2 className="dashboard-title">Building Maintenance Dashboard</h2>
        <div className="dashboard-actions">
          <button className="btn btn-primary" onClick={() => { setComingSoonFeature('View Alerts'); setIsComingSoonOpen(true); }}>
            <FontAwesomeIcon icon={faBell} /> View Alerts
          </button>
          <button className="btn btn-primary" onClick={() => { setComingSoonFeature('Generate Report'); setIsComingSoonOpen(true); }}>
            <FontAwesomeIcon icon={faCalendar} /> Generate Report
          </button>
        </div>
      </div>
      <div className="dashboard-cards-grid">
        {stats.map((item) => (
          <div key={item.key} className={`dashboard-card ${item.status}`} onClick={() => onNavigate && item.navTarget && onNavigate(item.navTarget)} role={item.navTarget ? 'button' : undefined} tabIndex={item.navTarget ? 0 : undefined}>
            <div className="dashboard-card-icon">
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <div className="dashboard-card-info">
              <div className="dashboard-card-label">{item.label}</div>
              <div className="dashboard-card-numbers">
                <span className="dashboard-card-total">{item.total}</span>
                {item.failed > 0 && (
                  <span className="dashboard-card-failed">{item.failed} Issues</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="dashboard-bottom-panels">
        <div className="dashboard-panel attention-panel">
          <div className="panel-title">
            <FontAwesomeIcon icon={faExclamationTriangle} /> Required Attention
          </div>
          {attentionItems.length > 0 ? (
            <ul className="attention-list">
              {attentionItems.map(item => (
                <li key={item.key}>
                  <FontAwesomeIcon icon={item.icon} className="attention-icon" />
                  <span className="attention-label">{item.label}:</span>
                  <span className="attention-failed">{item.failed} Issues</span>
                </li>
              ))}
            </ul>
          ) : (
            <div className="no-issues">All building maintenance systems are operational. No issues require attention.</div>
          )}
        </div>
        <div className="dashboard-panel next-inspection-panel">
          <div className="panel-title">
            <FontAwesomeIcon icon={faCalendar} /> Next Inspection
          </div>
          <div className="next-inspection-details">
            <span className="next-inspection-date">Next scheduled inspection: <b>April 1, 2024</b></span>
            <button className="btn btn-primary btn-small">
              <FontAwesomeIcon icon={faCalendar} /> Schedule Inspection
            </button>
          </div>
        </div>
      </div>
      <ComingSoonModal
        isOpen={isComingSoonOpen}
        onClose={() => setIsComingSoonOpen(false)}
        featureName={comingSoonFeature}
      />
    </div>
  );
};

export default BuildingMaintenanceDashboard;